/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PromotionCheckingRequest { 
    id?: number;
    execution: PromotionCheckingRequest.ExecutionEnum;
    cronExp?: string;
    event?: PromotionCheckingRequest.EventEnum;
}
export namespace PromotionCheckingRequest {
    export type ExecutionEnum = 'EVENT' | 'SCHEDULED';
    export const ExecutionEnum = {
        Event: 'EVENT' as ExecutionEnum,
        Scheduled: 'SCHEDULED' as ExecutionEnum
    };
    export type EventEnum = 'CUSTOMER_LOGIN_EVENT' | 'NEW_LOYALTY_MEMBER' | 'ON_INVOICE_SCAN_SUCCESS';
    export const EventEnum = {
        CustomerLoginEvent: 'CUSTOMER_LOGIN_EVENT' as EventEnum,
        NewLoyaltyMember: 'NEW_LOYALTY_MEMBER' as EventEnum,
        OnInvoiceScanSuccess: 'ON_INVOICE_SCAN_SUCCESS' as EventEnum
    };
}


